import React from 'react';
import { Clock, Shield, DollarSign, Users } from 'lucide-react';
import { features } from '../mock';

const iconMap = {
  'Timely Delivery': Clock,
  'Construction Guarantee': Shield,
  'No Hidden Charges': DollarSign,
  'No Subcontracting': Users
};

const Features = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Why <span className="text-orange-600">S4 Homes</span> Is Best for Turnkey Home Constructions?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We combine experience, transparency, and quality to deliver your dream home
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = iconMap[feature.title];
            return (
              <div
                key={index}
                className="group p-8 rounded-2xl bg-slate-50 hover:bg-white hover:shadow-xl transition-all duration-300 border border-transparent hover:border-orange-200"
              >
                <div className="bg-orange-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-orange-600 transition-colors duration-300">
                  <Icon className="w-8 h-8 text-orange-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;